module.exports = __webpack_public_path__ + "img/testing-mode.6619337e.svg";